module.exports = __webpack_public_path__ + "img/order-step8-b.6c338248.png";